module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/compass-465c8d4e811e60774ebcc4d82069dab1.svg";